import React, {useEffect, useState, useCallback, useMemo, useRef} from "react";
import PageSerch from '../SerchDocters/Components/PageSerch';
import DynamicBreadcrumbs from '../../../Uitiles/DynamicBreadcrumbs';
import BloodBankCard from './Components/BloodBankCard';
import Advertisement from '../SerchDocters/Components/Advertisement';
import Paginationnew from '../../../Uitiles/Paginationnew';
import { useLocation } from 'react-router-dom';
import PageSidebar from '../../../Uitiles/PageSidebar';
import "./styles/BloodBankBase.css";
import "./styles/BloodBankCard.css";
import "./styles/BloodBankSearch.css";

const Preloader = () => (
    <div className="bb-preloader">
        <div className="bb-spinner">
            <div className="bb-bounce1"></div>
            <div className="bb-bounce2"></div>
            <div className="bb-bounce3"></div>
        </div>
    </div>
);

const BloodBanksPage = () => {
    const locationObj = useLocation();
    const [location, setLocation] = useState({ lat: 17.307197, lng: 78.584616 });
    const [searchLocation, setSearchLocation] = useState(false);
    const [address, setAddress] = useState("");  
    const [isLoading, setIsLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedBloodGroup, setSelectedBloodGroup] = useState("");
    const [bloodBanks, setBloodBanks] = useState([]);
    const [error, setError] = useState(null);
    const isFetching = useRef(false);
    const fetchTimeout = useRef(null);
    const [sortBy, setSortBy] = useState("");
    const [sortOrder, setSortOrder] = useState("ASC");
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [page_size, setPageSize] = useState(20);
    const [advertisement, setAdvertisement] = useState([]);

    const queryParams = new URLSearchParams(locationObj.search);
    const searchFromUrl = queryParams.get('search');
    const latFromUrlat = queryParams.get('lat');
    const lngFromUrlng = queryParams.get('lng');
    const pageFromUrl = parseInt(queryParams.get('page'), 10);

    // Mock blood bank data for demonstration
    const mockBloodBanks = [
        {
            id: 1,
            name: "Apollo Blood Bank",
            location: "Bangalore",
            address: "123 MG Road, Bangalore, Karnataka",
            phone: "+91 9876543210",
            email: "info@apollobloodbank.com",
            lat: 12.9716,
            lng: 77.5946,
            hours: "24 Hours Open",
            services: ["Blood Donation", "Blood Testing", "Emergency Donations", "Platelet Collection"],
            bloodGroups: ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"],
            isEmergency: true,
            rating: 4.8,
            reviews: 1245
        },
        {
            id: 2,
            name: "Fortis Blood Center",
            location: "Mumbai",
            address: "456 Juhu Beach Road, Mumbai, Maharashtra",
            phone: "+91 9876543211",
            email: "mumbai@fortisbloodbank.com",
            lat: 19.0760,
            lng: 72.8777,
            hours: "6 AM - 10 PM",
            services: ["Blood Donation", "Blood Storage", "Cross Matching", "Blood Typing"],
            bloodGroups: ["O+", "O-", "A+", "B+"],
            isEmergency: false,
            rating: 4.5,
            reviews: 892
        },
        {
            id: 3,
            name: "Max Healthcare Blood Bank",
            location: "Delhi",
            address: "789 CP Market, Delhi, NCR",
            phone: "+91 9876543212",
            email: "delhi@maxbloodbank.com",
            lat: 28.6139,
            lng: 77.2090,
            hours: "7 AM - 9 PM",
            services: ["Blood Donation", "Component Separations", "Pathology Tests", "Emergency Services"],
            bloodGroups: ["AB+", "AB-", "B+", "O+"],
            isEmergency: true,
            rating: 4.9,
            reviews: 2156
        },
        {
            id: 4,
            name: "Manipal Blood Bank",
            location: "Chennai",
            address: "321 Anna Salai, Chennai, Tamil Nadu",
            phone: "+91 9876543213",
            email: "chennai@manipalbloodbank.com",
            lat: 13.0827,
            lng: 80.2707,
            hours: "24 Hours Open",
            services: ["Blood Donation", "Auto Donations", "Storage Services", "Quality Control"],
            bloodGroups: ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"],
            isEmergency: true,
            rating: 4.7,
            reviews: 1634
        },
        {
            id: 5,
            name: "Medanta Blood Center",
            location: "Gurgaon",
            address: "654 Cyber Greens, Gurgaon, Haryana",
            phone: "+91 9876543214",
            email: "gurgaon@medantabloodbank.com",
            lat: 28.4595,
            lng: 77.0296,
            hours: "6 AM - 11 PM",
            services: ["Blood Donation", "Plasma Collection", "Laboratory Services", "Emergency Response"],
            bloodGroups: ["AB+", "AB-", "A-", "B-", "O-"],
            isEmergency: false,
            rating: 4.6,
            reviews: 987
        }
    ];

    // Extract query parameters from URL
    useEffect(() => {
        const queryParams = new URLSearchParams(locationObj.search);
        const pageFromUrl = parseInt(queryParams.get('page'), 10);
        const searchFromUrl = queryParams.get('search');
        const latFromUrl = queryParams.get('lat');
        const lngFromUrl = queryParams.get('lng');

        if (!isNaN(pageFromUrl)) {
            setPage(pageFromUrl);
        }
        if (searchFromUrl) {
            setSearchTerm(searchFromUrl);
        }
        if (latFromUrl) {
            setLocation({ lat: latFromUrl, lng: lngFromUrl });
        }
        
        getAdvertisement();
        fetchBloodBanks();
    }, [locationObj.search]);

    const getAdvertisement = async () => {
        // Mock advertisement for blood banks section
        const mockAds = [
            {
                id: 1,
                title: "Blood Donation Drive",
                image: "/assets/images/blood-donation.jpg",
                description: "Join our monthly blood donation drive and save lives"
            },
            {
                id: 2,
                title: "Emergency Blood Services",
                image: "/assets/images/emergency-blood.jpg", 
                description: "24/7 emergency blood services available"
            }
        ];
        setAdvertisement(mockAds);
    };

    const fetchBloodBanks = useCallback(async () => {
        try {
            setIsLoading(true);
            setError(null);
            
            // Simulate API call delay
            await new Promise(resolve => setTimeout(resolve, 1000));
            
            // Filter blood banks based on search criteria
            let filteredBanks = mockBloodBanks;
            
            if (searchTerm) {
                filteredBanks = filteredBanks.filter(bank => 
                    bank.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    bank.location.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    bank.address.toLowerCase().includes(searchTerm.toLowerCase())
                );
            }
            
            if (selectedBloodGroup) {
                filteredBanks = filteredBanks.filter(bank => 
                    bank.bloodGroups.includes(selectedBloodGroup)
                );
            }
            
            // If location-based search is enabled
            if (searchLocation && location) {
                filteredBanks = filteredBanks.filter(bank => {
                    const distance = calculateDistance(
                        location.lat, location.lng, 
                        bank.lat, bank.lng
                    );
                    return distance <= 50; // 50km radius
                });
            }
            
            // Sorting
            if (sortBy) {
                filteredBanks.sort((a, b) => {
                    let aVal = a[sortBy];
                    let bVal = b[sortBy];
                    
                    if (sortBy === 'rating') {
                        aVal = a.rating;
                        bVal = b.rating;
                    } else if (sortBy === 'name') {
                        aVal = a.name.toLowerCase();
                        bVal = b.name.toLowerCase();
                    }
                    
                    if (sortOrder === 'ASC') {
                        return aVal > bVal ? 1 : -1;
                    } else {
                        return aVal < bVal ? 1 : -1;
                    }
                });
            }
            
            // Pagination
            const startIndex = (page - 1) * page_size;
            const endIndex = startIndex + page_size;
            const pagedBanks = filteredBanks.slice(startIndex, endIndex);
            
            setTotalPages(Math.ceil(filteredBanks.length / page_size));
            setBloodBanks(pagedBanks);
            
        } catch (err) {
            console.error('Error fetching blood banks:', err);
            setError(err.message || 'Failed to fetch blood banks data');
            setBloodBanks([]);
        } finally {
            setSearchLocation(false);
            setIsLoading(false);
            isFetching.current = false;
        }
    }, [location, searchTerm, page, page_size, selectedBloodGroup, sortBy, sortOrder]);

    const calculateDistance = (lat1, lng1, lat2, lng2) => {
        const R = 6371; // Earth's radius in kilometers
        const dLat = deg2rad(lat2 - lat1);
        const dLng = deg2rad(lng2 - lng1);
        const a = 
            Math.sin(dLat/2) * Math.sin(dLat/2) +
            Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * 
            Math.sin(dLng/2) * Math.sin(dLng/2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
        return R * c; // Distance in kilometers
    };

    const deg2rad = (deg) => deg * (Math.PI/180);

    // Memoize the blood banks list to prevent unnecessary re-renders
    const memoizedBloodBanks = useMemo(() => bloodBanks, [bloodBanks]);

    // Search effect
    useEffect(() => {
        if (fetchTimeout.current) {
            clearTimeout(fetchTimeout.current);
        }

        if (searchTerm || selectedBloodGroup || searchLocation) {
            setPage(1);
        }
    
        fetchTimeout.current = setTimeout(() => {
            const params = new URLSearchParams();
    
            if (searchTerm) params.set('search', searchTerm);
            if (location?.lat) params.set('lat', location.lat);
            if (location?.lng) params.set('lng', location.lng);
            if (page) params.set('page', page);
            if (selectedBloodGroup) params.set('blood_group', selectedBloodGroup);
            if (sortBy) params.set('sort_by', sortBy);
            if (sortOrder) params.set('sort_order', sortOrder);
    
            const newUrl = `/blood-banks?${params.toString()}`;
            window.history.replaceState(null, '', newUrl);
    
            fetchBloodBanks();
        }, 500);
    
        return () => {
            if (fetchTimeout.current) {
                clearTimeout(fetchTimeout.current);
            }
        };
    }, [searchTerm, location, page, sortBy, sortOrder, selectedBloodGroup]);

    const handleLocationChange = (newLocation) => {
        setSearchLocation(true);
        setLocation(newLocation);
    };

    const handleSortChange = (e) => {
        setSortBy(e.target.value);
    };

    const handlesortorder = (e) => {
        setSortOrder(e.target.value);
    };

    const handlePageChange = (pageNumber) => setPage(pageNumber);

    const handleSearch = (searchParams) => {
        console.log("handleSearch called with:", searchParams);
        const { searchTerm, selectedBloodGroup, selectedService, location } = searchParams;
        
        if (searchTerm !== undefined) setSearchTerm(searchTerm);
        if (selectedBloodGroup !== undefined) setSelectedBloodGroup(selectedBloodGroup);
        if (location) setLocation(location);
        
        setPage(1);
        setSearchLocation(true);
    };

    const bloodGroups = [
        { value: "", label: "All Blood Groups" },
        { value: "A+", label: "A+" },
        { value: "A-", label: "A-" },
        { value: "B+", label: "B+" },
        { value: "B-", label: "B-" },
        { value: "AB+", label: "AB+" },
        { value: "AB-", label: "AB-" },
        { value: "O+", label: "O+" },
        { value: "O-", label: "O-" }
    ];

    return (
        <div className="blood-bank-container">
            <PageSerch 
                location={location} 
                setLocation={handleLocationChange} 
                searchTerm={searchTerm} 
                setSearchTerm={setSearchTerm} 
                selectedBloodGroup={selectedBloodGroup} 
                setSelectedBloodGroup={setSelectedBloodGroup} 
                onSearch={handleSearch}
                placeholder="Search blood banks or locations..."
                bloodGroups={bloodGroups}
            />
            <DynamicBreadcrumbs />
            <main id="bb-main" className="bb-main bb-haslayout">
                <div className="bb-haslayout bb-parent-section">
                    <div className="container">
                        <div className="row">
                            <div id="bb-twocolumns" className="bb-twocolumns bb-haslayout d-flex bb-enabled">
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-9 order-first">
                                    {isLoading ? (
                                        <Preloader />
                                    ) : (
                                        <>
                                            <div className="bb-searchresult-holder">
                                                <div className="bb-searchresult-head">
                                                    <div className="bb-title">
                                                        <h4>
                                                            {error ? (
                                                                <span className="bb-text-danger">{error}</span>
                                                            ) : (
                                                                <strong>{memoizedBloodBanks.length}</strong>
                                                            )}&nbsp;blood banks found
                                                        </h4>
                                                    </div>
                                                    <div className="bb-rightarea">
                                                        <div className="bb-select">
                                                            <select name="orderby" className="orderby" onChange={handleSortChange} value={sortBy}>
                                                                <option value="">Sort By</option>
                                                                <option value="name">Name</option>
                                                                <option value="rating">Rating</option>
                                                                <option value="distance">Distance</option>
                                                            </select>
                                                        </div>
                                                        <div className="bb-select">
                                                            <select name="order" className="order" onChange={handlesortorder} value={sortOrder}>
                                                                <option value="ASC">Ascending</option>
                                                                <option value="DESC">Descending</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            {memoizedBloodBanks.map((bloodBank, index) => (
                                                <React.Fragment key={bloodBank.id}>
                                                    <BloodBankCard bloodBank={bloodBank} />
                                                    {(index + 1) % 5 === 0 && index !== memoizedBloodBanks.length - 1 && advertisement.length > 0 && (
                                                        <Advertisement advertisement={advertisement[(Math.floor(index / 5)) % advertisement.length]} />
                                                    )}
                                                </React.Fragment>
                                            ))}

                                            {memoizedBloodBanks.length === 0 && !isLoading && (
                                                <div className="bb-no-blood-banks-found">
                                                    <div className="bb-no-results-icon"></div>
                                                    <h3>No Blood Banks Found</h3>
                                                    <p>Try adjusting your search criteria or browse all blood banks.</p>
                                                </div>
                                            )}

                                            <div id="bb-blood-banks-results-pages">
                                                <div className="bb-paginationvtwo">
                                                    <Paginationnew currentPage={page} totalPages={totalPages} handlePageChange={handlePageChange} />
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>

                                <div className="col-12 col-md-5 col-lg-4 col-xl-3 order-last">
                                    <PageSidebar />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default React.memo(BloodBanksPage);
